export default {
    sidebar: {
        active: false
    },
    usuario: {
        menu: [],
        //nombre: '',
        usuarioId: 0,
        jerarquiaId: 0
    },
    toastService: {
        message: '',
        active: false
    },
    semestres: [{ "Id": 247, "Nombre": "1er. Semestre-CARRERA-FCA 2026", "año": 2026, "periodo": 1 }, { "Id": 2, "Nombre": "1er. Semestre-CARRERA-FCA 2025", "año": 2025, "periodo": 1 }],
    modalidades: ['D', 'S'],
}